<template>
  <div class="welcome-page">
    <div class="container text-center mt-5">
      <h1 class="display-4">Welcome, Admin!</h1>
      <p class="lead">This is your admin dashboard where you can manage the application.</p>

      <!-- Add a Login button -->
      <button 
        class="btn btn-primary btn-lg mt-4" 
        @click="goToLogin">
        Login
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToLogin() {
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.welcome-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f8f9fa;
}

h1 {
  font-size: 2.5rem;
  color: #343a40;
}

p {
  font-size: 1.25rem;
  color: #6c757d;
}

.btn {
  padding: 10px 20px;
  font-size: 1.25rem;
}
</style>
